import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { PageModule } from '@abp/ng.components/page';
import { InventoryLocationComponent } from './components/inventory-location.component';
import { InventoryLocationRoutingModule } from './inventory-location-routing.module';

@NgModule({
  declarations: [InventoryLocationComponent],
  imports: [
    InventoryLocationRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    PageModule
  ],
})
export class InventoryLocationModule {}

export function loadInventoryLocationModuleAsChild() {
  return Promise.resolve(InventoryLocationModule);
}
